module.exports = __webpack_public_path__ + "static/dolgaunt-0b9ed025c0ba15280bfdaf25a2c73fb2.png";